module.exports = __webpack_public_path__ + "img/bg-3-2.816c0324.png";